var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFamilyRoom = function SvgFamilyRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.101 5.995A1 1 0 1 1 7.76 4.35 5.027 5.027 0 0 1 9.14 2.898 3 3 0 1 0 4.908 7.15 4.002 4.002 0 0 0 2 11v5h2v-5a2 2 0 0 1 2-2h1.416a5.022 5.022 0 0 1-.315-3.005ZM17 7c0 .711-.148 1.388-.416 2H18a2 2 0 0 1 2 2v5h2v-5c0-1.83-1.23-3.374-2.909-3.85a3 3 0 1 0-4.232-4.253c.553.387 1.023.88 1.382 1.453a1 1 0 1 1 .659 1.645c.065.325.1.66.1 1.005Zm-4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1.091 2.15a3 3 0 1 0-4.183 0A4.002 4.002 0 0 0 7 13v5h2v4h6v-4h2v-5c0-1.83-1.23-3.374-2.909-3.85ZM15 13v3h-2v4h-2v-4H9v-3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2Z",
    clipRule: "evenodd"
  })));
};
export default SvgFamilyRoom;